// Normaliza a resposta de GET /customer/portal/layout/{host}.
//
// Hosts sem layout cadastrado recebem 200 com corpo vazio. O axios não
// consegue desserializar isso, então `resp.data` chega como a string vazia —
// que é falsy, mas NÃO é `undefined`. Guardas do tipo `data && data.layout`
// devolvem a própria string vazia e escondem o problema: o valor era
// persistido e o layout virava `undefined` mais adiante, fazendo o App
// retornar `undefined` do render (invariant #152 do React).
//
// Só um objeto plano conta como layout; qualquer outra coisa vira null, que os
// chamadores tratam como "sem layout cadastrado" e resolvem com o padrão.
function isPlainObject(value) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function extractLayout(data) {
  if (!isPlainObject(data)) return null;
  return isPlainObject(data.layout) ? data.layout : null;
}

export function extractCompanies(data) {
  if (!isPlainObject(data)) return null;
  return Array.isArray(data.companies) ? data.companies : null;
}
